import { z } from "zod";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { codeSchema } from "@platform/features/invitation/dialogs/OrgCodeDialog/orgCodeDialog.schemas";
import { validateOrgInvitation } from "@platform/utils/validateOrgInvitation";
import { usePlatformStore } from "@platform/store";

export function useSubmitCode() {
  const setInvitation = usePlatformStore((s) => s.setInvitation);

  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (data: z.infer<typeof codeSchema>) => {
      return await validateOrgInvitation({ code: data.code, type: "code" });
    },
    onSuccess: (data) => {
      setInvitation(data, "code_entry");

      setTimeout(() => {
        navigate(`/invitation/${data.shortcode}/join`);
      }, 2000);
    },
  });
}

export default useSubmitCode;

